/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_SystemSettings {
    ContactPersonOnboardingAccountSetupEmailTemplateSubject = 120,
    ContactPersonOnboardingAccountSetupEmailTemplateContent = 121,
    ContactPersonOnboardingAccountCreatedEmailTemplateSubject = 122,
    ContactPersonOnboardingAccountCreatedEmailTemplateContent = 123,
    DefaultTimeSpan = 124,
    BlackListedFileTypes = 125,
    CustomerPortalCustomerLoginOverrideURL = 710,
    DefaultProjectLabels = 720,
    SeedDataVersion = 810,
}
